import type { Partner } from '~/types/partner'

export type ScopedPartner = Pick<Partner, 'id' | 'name' | 'avatar' | 'metadata'>

interface PartnerOverview {
    partner: ScopedPartner
    distributors: ScopedPartner[]
    canManageDistributors: boolean
}

export function usePartnerOverview() {
    const overview = useState<PartnerOverview | null>('partner-overview', () => null)

    const scopedPartners = computed(() => overview.value
        ? [overview.value.partner, ...overview.value.distributors]
        : [])

    const quickActivationPartners = computed(() => scopedPartners.value.filter(p => p.metadata?.allow_quick_activation))

    // Partners created before this setting existed keep bulk activation until an admin turns it off.
    const canBulkActivate = computed(() => !!overview.value && overview.value.partner.metadata?.allow_bulk_activation !== false)

    async function load() {
        overview.value = await $fetch<PartnerOverview>('/api/partner/overview')
        return overview.value
    }

    function partnerName(id?: string) {
        return scopedPartners.value.find(p => p.id === id)?.name
    }

    return { overview, scopedPartners, quickActivationPartners, canBulkActivate, load, partnerName }
}
